import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-more",
  "use": "icon-home-item-more-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home-item-more\">\n<style type=\"text/css\">\n\t#icon-home-item-more .st0{enable-background:new    ;}\n</style>\n<path id=\"icon-home-item-more_tab_下拉\" class=\"st0\" d=\"M7.4,15l6.1-4.7c0.2-0.1,0.2-0.4,0.1-0.6c0,0-0.1-0.1-0.1-0.1L7.4,5c-0.4-0.3-1-0.1-1,0.3v9.3\n\tC6.4,15.1,7,15.3,7.4,15z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-more.svg
// module id = 4mfW
// module chunks = 97